/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Chip
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PrintIcon from "@material-ui/icons/Print";
import CloseIcon from "@material-ui/icons/Close";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import { SalaryService } from "_services/salary.service";
import hospitalLogo from "assets/img/logo2.png";
import moment from "moment";
import "moment/locale/th";

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflowX: "hidden"
  },
  slipContainer: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: "210mm",
    margin: "0 auto",
    padding: "16px 20px 20px",
    backgroundColor: "#fff",
    fontFamily: '"Salary Slip Sarabun", "TH Sarabun New", "Sarabun", "Tahoma", sans-serif',
    color: "#000",
    fontSize: "16pt",
    lineHeight: 1.2
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "2.5mm",
    paddingBottom: "1.5mm",
    borderBottom: "1.5px solid #000",
    breakInside: "avoid"
  },
  logo: {
    width: "17mm",
    height: "17mm",
    objectFit: "contain",
    flexShrink: 0
  },
  headerTitle: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "18pt",
    lineHeight: 1.15,
    whiteSpace: "nowrap"
  },
  subHeader: {
    margin: "0",
    fontSize: "16pt",
    lineHeight: 1.2,
    whiteSpace: "nowrap"
  },
  personnelSection: {
    marginTop: "2.5mm",
    marginBottom: "2.5mm",
    breakInside: "avoid"
  },
  dateHeader: {
    marginBottom: "1.5mm",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "17pt"
  },
  personnelInfo: {
    display: "grid",
    gridTemplateColumns: "25mm minmax(0, 1fr)",
    margin: 0,
    rowGap: "0.6mm",
    fontSize: "16pt",
    lineHeight: 1.15,
    "& dt, & dd": {
      margin: 0,
      fontWeight: "normal"
    }
  },
  salaryTable: {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    backgroundColor: "#ffffff",
    "& th, & td": {
      border: "1px solid #000",
      padding: "1mm 2mm",
      verticalAlign: "middle",
      overflowWrap: "break-word",
      fontSize: "17px",
      color: "#000000 !important",
      WebkitPrintColorAdjust: "exact !important",
      printColorAdjust: "exact !important"
    },
    "& thead": {
      display: "table-header-group",
      backgroundColor: "#f6f8dc"
    },
    "& thead th": {
      backgroundColor: "#f6f8dc !important",
      color: "#000000 !important",
      WebkitPrintColorAdjust: "exact !important",
      printColorAdjust: "exact !important"
    },
    "& td": {
      backgroundColor: "#ffffff !important",
      color: "#000000 !important",
      WebkitPrintColorAdjust: "exact !important",
      printColorAdjust: "exact !important"
    },
    "& tr": {
      breakInside: "avoid",
      pageBreakInside: "avoid",
      fontSize: "17px"
    }
  },
  numberColumn: {
    width: "48px"
  },
  amountColumn: {
    width: "135px"
  },
  numberCell: {
    textAlign: "center",
    whiteSpace: "nowrap",
    color: "#000000 !important"
  },
  descriptionHeader: {
    textAlign: "left",
    color: "#000000 !important"
  },
  amountHeader: {
    textAlign: "right",
    paddingRight: "2.5mm",
    color: "#000000 !important"
  },
  sectionHeader: {
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#f6f8dc !important",
    color: "#000000 !important",
    WebkitPrintColorAdjust: "exact !important",
    printColorAdjust: "exact !important"
  },
  amountCell: {
    textAlign: "right",
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums",
    paddingRight: "2.5mm !important",
    paddingLeft: "4px",
    backgroundColor: "#ffffff !important",
    color: "#000000 !important",
    boxSizing: "border-box"
  },
  totalLabel: {
    textAlign: "right",
    fontWeight: "bold",
    backgroundColor: "#fafafa !important",
    color: "#000000 !important"
  },
  netPayLabel: {
    border: "none !important",
    textAlign: "right",
    fontWeight: "bold",
    backgroundColor: "#ffffff !important",
    color: "#000000 !important"
  },
  signatureSection: {
    marginTop: "8mm",
    textAlign: "center",
    breakInside: "avoid",
    pageBreakInside: "avoid"
  },
  signatureLine: {
    display: "inline-block",
    width: "45mm",
    margin: "0 1mm",
    borderBottom: "1px dotted #000"
  },
  "@media print": {
    slipContainer: {
      width: "100%",
      minWidth: 0,
      maxWidth: "100%",
      margin: 0,
      padding: 0
    }
  }
}));

const formatMoney = value => {
  if (value === undefined || value === null || value === "") return "0.00";
  const num = Number(value);
  if (isNaN(num)) return String(value);
  return num.toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const formatPrintDate = value => {
  if (!value) return "-";
  const date = moment(value, ["DD/MM/YYYY HH:mm", "DD/MM/YYYY", moment.ISO_8601], true);
  if (!date.isValid()) return value;
  if (date.year() < 2400) date.add(543, "years");
  return date.locale("th").format("D MMMM YYYY");
};

const DOC_WIDTH = 680;

export default function SalarySlipDialog({ open, onClose, userName, calYear, calMonth, initialSlip = null }) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [slip, setSlip] = useState(initialSlip);

  // Zoom / Scale state for Preview
  const containerRef = useRef(null);
  const slipRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [zoomMode, setZoomMode] = useState("fit"); // "fit" or "100"
  const [unscaledHeight, setUnscaledHeight] = useState(650);

  useEffect(() => {
    if (initialSlip) {
      setSlip(initialSlip);
    } else if (open && userName && calYear && calMonth) {
      loadSlip();
    }
  }, [open, userName, calYear, calMonth, initialSlip]);

  // Recalculate zoom out scale so document fits in viewport without scrolling down
  useEffect(() => {
    if (!open) return;

    const calculateScale = () => {
      if (!containerRef.current) return;
      const containerWidth = containerRef.current.clientWidth;
      const docHeight = slipRef.current ? slipRef.current.offsetHeight : unscaledHeight;

      if (docHeight > 0 && docHeight !== unscaledHeight) {
        setUnscaledHeight(docHeight);
      }

      if (zoomMode === "fit") {
        const isMobile = window.innerWidth <= 768;
        const availableWidth = Math.max(100, (containerWidth > 0 ? containerWidth : window.innerWidth) - (isMobile ? 16 : 24));

        // Available vertical space inside modal without scrolling down
        const chromeHeight = isMobile ? 120 : 178;
        const availableHeight = Math.max(180, window.innerHeight - chromeHeight);

        const scaleW = availableWidth / DOC_WIDTH;
        const docH = docHeight > 0 ? docHeight : 650;
        const scaleH = availableHeight / docH;

        // Scale down to fit BOTH width and height so the entire document is visible without scrolling down
        const calculatedScale = Math.max(0.15, Math.min(1, scaleW, scaleH));
        setScale(calculatedScale);
      } else {
        setScale(1);
      }
    };

    calculateScale();
    const t1 = setTimeout(calculateScale, 40);
    const t2 = setTimeout(calculateScale, 180);
    const t3 = setTimeout(calculateScale, 450);

    window.addEventListener("resize", calculateScale);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      window.removeEventListener("resize", calculateScale);
    };
  }, [open, slip, zoomMode, unscaledHeight]);

  const loadSlip = async () => {
    setLoading(true);
    try {
      const res = await SalaryService.getSalarySlip(userName, calYear, calMonth);
      if (res.data && res.data.success && res.data.data) {
        setSlip(res.data.data);
      }
    } catch (err) {
      console.error("Error loading salary slip:", err);
      alert("ไม่สามารถโหลดสลิปเงินเดือนได้");
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const isScaledDown = scale < 0.98;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth className="salary-slip-dialog">
      <style>{`
        @font-face {
          font-family: 'Salary Slip Sarabun';
          src: url('${process.env.PUBLIC_URL || ""}/thsarabun.ttf') format('truetype');
          font-style: normal;
          font-weight: 400;
          font-display: swap;
        }
        @font-face {
          font-family: 'Salary Slip Sarabun';
          src: url('${process.env.PUBLIC_URL || ""}/thsarabunbold.ttf') format('truetype');
          font-style: normal;
          font-weight: 700;
          font-display: swap;
        }
        .salary-slip-dialog table thead th,
        .salary-slip-dialog table th,
        .salary-slip-dialog .sectionHeader {
          background-color: #f6f8dc !important;
          background: #f6f8dc !important;
          color: #000000 !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
        .salary-slip-dialog table td {
          background-color: #ffffff !important;
          background: #ffffff !important;
          color: #000000 !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
        @media screen and (max-width: 768px) {
          .salary-slip-dialog .MuiDialog-paper {
            margin: 6px !important;
            width: calc(100% - 12px) !important;
            max-width: calc(100% - 12px) !important;
            max-height: calc(100% - 12px) !important;
            border-radius: 8px !important;
          }
        }
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
          *,
          *::before,
          *::after {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
            box-sizing: border-box !important;
          }
          html, body {
            height: auto !important;
            width: 100% !important;
            min-width: 0 !important;
            max-width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: visible !important;
            background: #ffffff !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          .container {
            min-width: 0 !important;
          }
          #root, .sidebar, .navbar, footer, .footer, .no-print {
            display: none !important;
          }
          .salary-slip-dialog {
            position: static !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .salary-slip-dialog .MuiDialog-container {
            position: static !important;
            display: block !important;
            height: auto !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
          }
          .salary-slip-dialog .MuiDialog-paper {
            box-shadow: none !important;
            border: none !important;
            margin: 0 auto !important;
            padding: 0 !important;
            max-width: 100% !important;
            max-height: none !important;
            width: 100% !important;
            min-width: 0 !important;
            overflow: visible !important;
            background: #ffffff !important;
          }
          .salary-slip-dialog .MuiDialogTitle-root,
          .salary-slip-dialog .MuiDialogActions-root,
          .salary-slip-dialog .MuiBackdrop-root {
            display: none !important;
          }
          .salary-slip-dialog .MuiDialogContent-root {
            border: none !important;
            padding: 0 !important;
            margin: 0 !important;
            overflow: visible !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
          }
          .preview-outer-wrapper {
            overflow: visible !important;
            padding: 0 !important;
            margin: 0 !important;
            background: transparent !important;
            display: block !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
          }
          .preview-scaler-viewport,
          .preview-scaler-canvas,
          .preview-scaler-box,
          .preview-scaler-box > div {
            transform: none !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            height: auto !important;
            margin: 0 !important;
            padding: 0 !important;
            box-shadow: none !important;
            border: none !important;
            overflow: visible !important;
            background: transparent !important;
          }
          #printable-salary-slip {
            display: block !important;
            box-sizing: border-box !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            margin: 0 auto !important;
            padding: 10mm 15mm 8mm 15mm !important;
            overflow: visible !important;
            background: #ffffff !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
            page-break-after: avoid !important;
            break-after: avoid !important;
          }
          #printable-salary-slip table,
          .salary-slip-dialog table {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            box-sizing: border-box !important;
            table-layout: fixed !important;
            border-collapse: collapse !important;
            background-color: #ffffff !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
          #printable-salary-slip th,
          #printable-salary-slip td,
          .salary-slip-dialog table th,
          .salary-slip-dialog table td {
            border: 1px solid #000000 !important;
            box-sizing: border-box !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          #printable-salary-slip thead,
          #printable-salary-slip thead tr,
          #printable-salary-slip thead th,
          .salary-slip-dialog table thead,
          .salary-slip-dialog table thead tr,
          .salary-slip-dialog table thead th,
          .salary-slip-dialog table th,
          .salary-slip-dialog tr th,
          .salary-slip-dialog .salaryTable thead th {
            background-color: #f6f8dc !important;
            background: #f6f8dc !important;
            color: #000000 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          #printable-salary-slip tbody th,
          #printable-salary-slip .sectionHeader,
          .salary-slip-dialog th.sectionHeader,
          .salary-slip-dialog .sectionHeader {
            background-color: #f6f8dc !important;
            background: #f6f8dc !important;
            color: #000000 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          #printable-salary-slip tbody td,
          .salary-slip-dialog table td {
            background-color: #ffffff !important;
            background: #ffffff !important;
            color: #000000 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          .salary-slip-dialog td.totalLabel,
          #printable-salary-slip td.totalLabel {
            background-color: #fafafa !important;
            background: #fafafa !important;
            color: #000000 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          .salary-slip-dialog td.netPayLabel,
          #printable-salary-slip td.netPayLabel {
            background-color: #ffffff !important;
            background: #ffffff !important;
            color: #000000 !important;
            border: none !important;
          }
          .salary-slip-dialog .numberColumn,
          #printable-salary-slip .numberColumn {
            width: 48px !important;
          }
          .salary-slip-dialog .amountColumn,
          #printable-salary-slip .amountColumn {
            width: 135px !important;
          }
          .salary-slip-dialog .amountCell,
          #printable-salary-slip .amountCell {
            padding-right: 2.5mm !important;
            text-align: right !important;
            white-space: nowrap !important;
          }
        }
      `}</style>
      <DialogTitle style={{ padding: "10px 16px", borderBottom: "1px solid #e2e8f0" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="h6" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              สลิปเงินเดือน
            </Typography>
            {/* Zoom Out / Full Size Toggle on Screen */}
            {(isScaledDown || zoomMode === "100") && (
              <Chip
                size="small"
                icon={zoomMode === "fit" ? <ZoomInIcon style={{ fontSize: 16 }} /> : <AspectRatioIcon style={{ fontSize: 14 }} />}
                label={zoomMode === "fit" ? `ย่อพอดีจอ (${Math.round(scale * 100)}%)` : "ขนาดจริง 100%"}
                onClick={() => setZoomMode(zoomMode === "fit" ? "100" : "fit")}
                style={{
                  cursor: "pointer",
                  backgroundColor: zoomMode === "fit" ? "#e0f2fe" : "#fef3c7",
                  color: zoomMode === "fit" ? "#0369a1" : "#92400e",
                  fontWeight: "bold",
                  fontSize: "0.75rem"
                }}
              />
            )}
          </Box>
          <Box display="flex" gap={1}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<PrintIcon />}
              onClick={handlePrint}
              disabled={loading || !slip}
              style={{ backgroundColor: "#2563eb", fontWeight: "bold" }}
            >
              พิมพ์สลิป
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={onClose}
              style={{ minWidth: 40, padding: "4px 8px" }}
            >
              <CloseIcon fontSize="small" />
            </Button>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent} ref={containerRef}>
        {loading ? (
          <Box py={6} textAlign="center">
            <CircularProgress />
            <Typography style={{ marginTop: 8 }}>กำลังโหลดสลิปเงินเดือน...</Typography>
          </Box>
        ) : slip ? (
          <div
            className="preview-outer-wrapper"
            style={{
              width: "100%",
              overflowX: zoomMode === "100" ? "auto" : "hidden",
              overflowY: zoomMode === "100" ? "auto" : "hidden",
              padding: scale < 1 ? "8px 0" : 0,
              backgroundColor: scale < 1 ? "#f1f5f9" : "#fff",
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {/* Viewport container: takes exact scaled dimensions and centers with margin: 0 auto */}
            <div
              className="preview-scaler-viewport"
              style={{
                width: scale < 1 ? Math.round(DOC_WIDTH * scale) : (zoomMode === "100" ? DOC_WIDTH : "100%"),
                maxWidth: "100%",
                height: scale < 1 && unscaledHeight > 0 ? Math.round(unscaledHeight * scale) : "auto",
                margin: "0 auto",
                position: "relative",
                overflow: "hidden",
                boxShadow: scale < 1 ? "0 4px 16px rgba(0,0,0,0.12)" : "none",
                borderRadius: scale < 1 ? 6 : 0,
                backgroundColor: "#fff",
                boxSizing: "border-box"
              }}
            >
              {/* Canvas container: fixed 680px width, scales from top-left into the viewport */}
              <div
                className="preview-scaler-canvas"
                style={{
                  width: DOC_WIDTH,
                  transform: scale < 1 ? `scale(${scale})` : "none",
                  transformOrigin: "top left",
                  backgroundColor: "#fff",
                  boxSizing: "border-box"
                }}
              >
                <div className={classes.slipContainer} id="printable-salary-slip" ref={slipRef}>
                  <header className={classes.header}>
                    <img className={classes.logo} src={hospitalLogo} alt="ตรากระทรวงสาธารณสุข" />
                    <div>
                      <h1 className={classes.headerTitle}>
                        โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                      </h1>
                      <p className={classes.subHeader}>
                        ใบรับรองการจ่ายเงินเดือน-ค่าจ้างประจำและเงินอื่น
                      </p>
                    </div>
                  </header>

                  <section className={classes.personnelSection}>
                    <div className={classes.dateHeader}>
                      ประจำเดือน {slip.monthName} พ.ศ. {slip.calYear}
                    </div>
                    <dl className={classes.personnelInfo}>
                      <dt style={{ fontWeight: "bold" }}>ชื่อ-นามสกุล</dt>
                      <dd>{slip.fullName}</dd>
                      <dt style={{ fontWeight: "bold" }}>หน่วยงาน</dt>
                      <dd>
                        โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง กรมการแพทย์
                      </dd>
                      <dt style={{ fontWeight: "bold" }}>จังหวัด</dt>
                      <dd>{slip.province || "ตรัง"}</dd>
                      <dt style={{ fontWeight: "bold" }}>โอนเข้าบัญชี</dt>
                      <dd>{slip.bankName || "-"}</dd>
                      <dt style={{ fontWeight: "bold" }}>เลขที่บัญชี</dt>
                      <dd>{slip.accountNo || "-"}</dd>
                    </dl>
                  </section>

                  <table className={classes.salaryTable} aria-label="รายละเอียดรายรับและรายจ่ายเงินเดือน">
                    <colgroup>
                      <col className={classes.numberColumn} style={{ width: "48px" }} />
                      <col style={{ width: "auto" }} />
                      <col className={classes.amountColumn} style={{ width: "135px" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col" className={classes.numberCell}>ลำดับ</th>
                        <th scope="col" className={classes.descriptionHeader}>รายการ</th>
                        <th scope="col" className={classes.amountHeader}>จำนวนเงิน(บาท)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th colSpan={3} className={classes.sectionHeader}>รายรับ</th>
                      </tr>
                      {slip.incomes && slip.incomes.length > 0 ? (
                        slip.incomes.map((item, index) => (
                          <tr key={item.id || index}>
                            <td className={classes.numberCell}>{index + 1}.</td>
                            <td>{item.name}</td>
                            <td className={classes.amountCell}>{formatMoney(item.value ?? item.Value ?? item.incomeValue ?? 0)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} className={classes.sectionHeader}>- ไม่มีรายการ -</td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan={2} className={classes.totalLabel}>รวม</td>
                        <td className={classes.amountCell} style={{ fontWeight: "bold" }}>
                          {formatMoney(slip.totalIncome ?? slip.TotalIncome ?? 0)}
                        </td>
                      </tr>
                      <tr>
                        <th colSpan={3} className={classes.sectionHeader}>รายจ่าย</th>
                      </tr>
                      {slip.outcomes && slip.outcomes.length > 0 ? (
                        slip.outcomes.map((item, index) => (
                          <tr key={item.id || index}>
                            <td className={classes.numberCell}>{index + 1}.</td>
                            <td>{item.name}</td>
                            <td className={classes.amountCell}>{formatMoney(item.value ?? item.Value ?? item.outcomeValue ?? 0)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} className={classes.sectionHeader}>- ไม่มีรายการหัก -</td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan={2} className={classes.totalLabel}>รวม</td>
                        <td className={classes.amountCell} style={{ fontWeight: "bold" }}>
                          {formatMoney(slip.totalOutcome ?? slip.TotalOutcome ?? 0)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} className={classes.netPayLabel}>รับสุทธิ</td>
                        <td className={classes.amountCell} style={{ fontWeight: "bold" }}>
                          {formatMoney(slip.netSalary ?? slip.NetSalary ?? 0)}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <section className={classes.signatureSection}>
                    <div>
                      ลงชื่อ<span className={classes.signatureLine} />ผู้มีหน้าที่จ่ายเงิน
                    </div>
                    <div>{formatPrintDate(slip.printDate)}</div>
                    <div>วันที่ออกหนังสือรับรอง</div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </DialogContent>

      <DialogActions style={{ padding: "8px 16px" }}>
        <Button onClick={onClose} startIcon={<CloseIcon />}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
